import { getMobileOtp, getEmailOtp } from "../../../utils/loggingApiService";
import {validateMobileNumber, validateEmail} from "./validator"

export const updateUserSelectedInput = (value,userDetail, setUserDetail) => {
    if (value === 'email') {
        return setUserDetail({...userDetail, selectedInput: value, mobileNumber:"" })
    }
    if (value === 'mobile') {
        return setUserDetail({...userDetail, selectedInput: value, email: "" })
    }
}

export const handleUserInput = (value, userDetail, setUserDetail) => {
    if (userDetail.selectedInput === 'mobile') {
        return setUserDetail({...userDetail, mobileNumber: value })
    }

    if (userDetail.selectedInput === 'email') {
        return setUserDetail({...userDetail, email: value })
    }
}

export const handleRequestOtp = async (userDetail, setUserDetail) => {
    let validation ;
    if (userDetail.selectedInput === 'mobile' ) {
        validation = validateMobileNumber(userDetail.mobileNumber)
        if (validation) {
            let mobileOtpResponse = await getMobileOtp(userDetail.mobileNumber)
            setUserDetail({...userDetail, newUser: mobileOtpResponse.data.register })
            return {
                status: mobileOtpResponse.status,
                userDetails : {...userDetail, newUser: mobileOtpResponse.data.register },
                message:""
            }
        } else {
            return {
                status : false ,
                message : "Invalid Mobile Number"
            }
        }
    }   

    if ( userDetail.selectedInput === 'email' ) {
        validation = validateEmail(userDetail.email)
        if (validation) {
            let emailOtpResponse = await getEmailOtp(userDetail.email)
            setUserDetail({...userDetail, newUser: emailOtpResponse.data.register })
            return {
                status: emailOtpResponse.status,
                userDetails : {...userDetail, newUser: emailOtpResponse.data.register },
                message:""
            }
        } else {
            return {
                status : false ,
                message : "Invalid Email Address"
            }
        }
    }


}
